<template>
  <button @click="handleClick" class="icon-button" :class="{ border, rounded }">
    <iconify-icon icon="svg-spinners:ring-resize" v-if="loading" />
    <slot v-else>
      <iconify-icon :icon="icon" />
    </slot>
  </button>
</template>

<script>
  export default {
    name: 'WIconButton',
    emits: ['click', 'force-click'],
    props: {
      rounded: { type: Boolean, default: true },
      outlined: Boolean,
      icon: { type: String, default: 'fa6-regular:face-grin-stars' },
      loading: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
      border: { type: Boolean, default: false },
    },
    methods: {
      handleClick() {
        if (!this.disabled && !this.loading) {
          this.$emit('click');
        }
        if (this.disabled) {
          this.forceClick();
        }
      },
      handleForceClick() {
        this.$emit('force-click');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/variables';

  .icon-button {
    height: 2.5rem;
    width: 2.5rem;
    aspect-ratio: 1;
    padding: 0.125rem;
    font-size: 1.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    cursor: pointer;
    border-radius: 0.375rem;

    &.border {
      border: 1px solid $input-border;
    }

    &.rounded {
      border-radius: 10000px;
    }
  }
</style>
